import React from 'react'

const Disclaimer = props => {
    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h1 className="mt-4 mb-4">Disclaimer</h1>
                    <p className="alert alert-danger">The content of these profiles is strictly confidential and for internal use only</p>
                    <p><strong>Disclaimer:</strong> the content of the profiles is constantly updated. It is strongly advised to always check for updates. Please contact the Resource Mobilization team (Division of External Affairs) if you have any questions.</p>
                    <p>The main purpose of these profiles is to gather internal and publicly available information in relation to contributors and potential contributors to inform and enrich GCF’s engagement and interactions with them. The online profile is also used for file management of all relevant documents.</p>
                    <p>The profile structure includes:</p>
                    <ul>
                        <li>Key Messages and Key Asks for bilateral meetings</li>
                        <li>Status of Contributions</li>
                        <li>Country Priorities for Climate Change (Climate Finance Policies, ODA Policies, National Climate Policies)</li>
                        <li>Country Overview (Financial Status, Authorizing Environment, Elections)</li>
                        <li>Recent Interactions and Engagements</li>
                        <li>Contacts (Board Members/Alternate Board Members/Advisors & key Ministers)</li>
                        <li>List of AEs with HQs in the country</li>
                        <li>List of Approved Projects by AE</li>
                        <li>List of Pipeline Projects by AE</li>
                        <li>Relevant documents (Research Memos, Meeting Notes, Contribution Agreements, Encashment Schedule, etc.)</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Disclaimer